import axios from "axios";
import { uri } from "../help/Api";
import { sto } from "../Context/InshData";

export function useAPI(subURL) {
  const URL = uri + subURL;
  function list() {
    return axios.get(URL);
  }
  function getNewId() {
    return axios.get(URL + "/newId");
  }
  function createFun(data) {
    return axios.post(URL, data);
  }

  function updateFun(data) {
    // console.log("the data is", data)
    return axios.put(URL, data);
  }
  function removeFun(id) {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `${subURL}?id=${id}`
    } else {
      Urls = `${subURL}?id=${id}&&db_name=${sto?.db_name}`
    }
    return axios.delete(uri + Urls);
  }

  function GetRow(data) {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `?branch=${data.branch}&&id=${data?.id}
      &&gettingType=${data.gettingType}`;
    } else {
      Urls = `?branch=${data.branch}&&id=${data?.id}
      &&gettingType=${data.gettingType}&&db_name=${sto?.db_name}`;
    }
    return axios.get(URL + Urls)
  }

  return { URL, getNewId, list, createFun, updateFun, removeFun, GetRow };
}
